import TextInputWithError from "../../inputs/TextInputWithError";
import { scopeIdInput } from "./index";

export default {
  templateCategoryName: {
    InputComponent: TextInputWithError,
    label: "Template Category Name",
    name: "name",
    fullWidth: true,
    required: true,
  },
  scopeId: scopeIdInput,
};
